// src/services/api-config.js
import axios from 'axios';

// In development (empty), requests go to same origin and are proxied
// In production, use the configured API URL
const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor to include organization ID in headers
api.interceptors.request.use(config => {
    // Get current organization from localStorage
    const currentOrganization = localStorage.getItem('currentOrganization');

    if (currentOrganization) {
        const org = JSON.parse(currentOrganization);
        // Set organization ID in headers for all requests
        config.headers['X-Organization-ID'] = org.id;
    }

    return config;
}, error => {
    return Promise.reject(error);
});

// Add response interceptor to handle organization-related errors
api.interceptors.response.use(response => response, error => {
    // Handle 403 errors related to organization access
    if (error.response && error.response.status === 403 &&
        error.response.data && error.response.data.detail === 'Organization access denied') {
        // Redirect to organizations page or show error
        alert('You do not have access to this organization.');
        window.location.href = '/organizations';
    }
    return Promise.reject(error);
});

export default api;
